export enum SubscriptionPackage {
  STARTER = 'starter',
  PROFESSIONAL = 'professional',
  ENTERPRISE = 'enterprise',
  PRO_SEMI_ANNUAL = 'pro_semi_annual',
}

export interface SubscriptionPackageInfo {
  id: SubscriptionPackage;
  name: string;
  price: number;
  annual_price: number;
  description: string | null;
  features: string[];
  stripe_price_id: string;
  annual_stripe_price_id: string | null;
  annual_discount_percentage: number;
  is_active: boolean;
  display_order: number;
  created_at: string;
  updated_at: string;
}
